<script>
  export let isEmpty = true;
</script>

<svg
  class="Icon"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="black"
  aria-hidden="true"
  xmlns="http://www.w3.org/2000/svg"
>
  {#if isEmpty}
    <path
      d="M1 1c-.6 0-1 .4-1 1s.4 1 1 1h1.7c.1 0 .3 0 .5.5.1.2.2.5.2.8l.1.3c0
      .2.1.4.1.6.1.5.8 2.9 1.5 5.2l.9 3.1.2.7-.2.2c-.5.5-.8 1.3-.8 2.4 0 1.8 1.7
      3.2 3.3 3.2H20c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2h3c.6 0 1-.4
      1-1s-.4-1-1-1H8.5c-.7 0-1.3-.6-1.3-1.2 0-.7.2-1 .3-1.1l.1-.1 15.4-.8c.6 0
      1-.5.9-1.1 0-.5-.5-.9-1-.9h-.3L24
      5.2c.1-.5-.3-1.1-.8-1.2H5.4v-.1c-.1-.4-.2-.8-.4-1.2C4.7 2 4.1 1 2.7
      1H1zm5.6 7.2L5.9 6h15.9l-1.2 6.9-12.5.6-.2-.6c-.4-1.5-.9-3.1-1.3-4.7zM8
      24c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
      fill-rule="evenodd"
      clip-rule="evenodd"
    />
  {:else}
    <circle cx="8" cy="22" r="2" />
    <path
      d="M23.6 19.8c-1.6-.3-3.2-.9-4.5-1.8H8.5c-.7 0-1.3-.6-1.3-1.2 0-.7.2-1
      .3-1.1l.1-.1
      8.2-.4c-.5-.6-.9-1.2-1.3-1.9l-6.5.3-.2-.6c-.3-1.6-.8-3.2-1.2-4.8L5.9
      6H13c.1-.7.2-1.4.3-2h-8v-.1c0-.4-.1-.8-.3-1.2C4.7 2 4.1 1 2.7 1H1c-.6 0-1
      .4-1 1s.4 1 1 1h1.7c.1 0 .3 0 .5.5.1.2.2.5.2.8l.1.3c0 .2.1.4.1.6.1.5.8 2.9
      1.5 5.2l.9 3.1.2.7-.2.2c-.5.5-.8 1.3-.8 2.4 0 1.8 1.7 3.2 3.3 3.2H23c.2 0
      .4-.1.6-.2z"
    />
    <circle cx="20" cy="22" r="2" />
  {/if}
</svg>

<style>.Icon {
  box-sizing: border-box;
  display: block;
  position: relative;
  line-height: 1;
  width: 24px;
  min-width: 24px;
  max-width: 24px;
  height: 24px;
  min-height: 24px;
  max-height: 24px;
  fill: var(--color-text, #1a1a1a);
}</style>
